import api from 'api';

export const JPEG_DOWNLOAD_START = 'JPEG_DOWNLOAD_START';
export const JPEG_DOWNLOAD_ERROR = 'JPEG_DOWNLOAD_ERROR';
export const JPEG_EXTERNAL_ASYNC_SUCCESS = 'JPEG_EXTERNAL_ASYNC_SUCCESS';

function jpegDownloadStart() {
  return {
    type: JPEG_DOWNLOAD_START,
  };
}

function jpegDownloadError() {
  return {
    type: JPEG_DOWNLOAD_ERROR,
  };
}
function externalJpegSuccess(data, fileName) {
  return {
    type: JPEG_EXTERNAL_ASYNC_SUCCESS,
    data,
    fileName,
  };
}


export function getExternalJpegAsync(url, fileName) {
  return (dispatch) => {
    dispatch(jpegDownloadStart());
    return api.requestExternalNoCache(url, 'get')
    .then((data) => {
      dispatch(externalJpegSuccess(data, fileName));
      return data;
    })
    .catch((err) => {
      dispatch(jpegDownloadError());
      throw (err);
    });
  };
}
/**
 * Download custom designs
 * @param {Array} urls - urls for images to download
 * @param {String} fileName  - file name to save the jpeg
 * @returns single promise
 */
export function getMultipleJpegAsync(urls, fileName) {
  const promises = [];
  return (dispatch) => {
    urls.forEach(url => {
      promises.push(
        new Promise((resolve, reject) => {
          dispatch(jpegDownloadStart());
          return api.requestExternalNoCache(url, 'get')
            .then((data) => {
              dispatch(externalJpegSuccess(data, fileName));
              return resolve(data);
            })
            .catch((err) => {
              dispatch(jpegDownloadError());
              return reject(err);
            });
        })
      );
    });
    return Promise.all(promises);
  };
}
